import createInstance from '../util'
import { BaseResponse } from '../common'

let triggerInstance = createInstance('v1/trigger')

/**
 * 计划委托/ 止盈止损下单
 * v1/trigger/plan/placePlan   单向持仓需求，此接口变更为 /v1/trigger/tracking/plan/placePlan
 * @param data
 */
export function placePlan(data: Partial<MixContractOpenParam>, header = {'x-security-verify-cipher': null }): Promise<BaseResponse<any>> {
    return triggerInstance.post('plan/placePlan', data, header)
}

/**
 * 追踪委托/ 移动止盈止损下单
 * @param data
 */
export function TrackPlan(data: Partial<MixContractOpenParam>, header = { 'x-security-verify-cipher': null }): Promise<BaseResponse<any>> {
    return triggerInstance.post('tracking/plan/placePlan', data, header)
}

/**
 * 仓位止盈止损合并下单
 * @param data
 */
export function PositionPlacePlan(data: Partial<MixContractOpenParam>): Promise<BaseResponse<any>> {
    return triggerInstance.post('tracking/plan/app/placePlan', data)
}

/**
 * 同时设置止盈止损、仓位止盈止损（主要用于设置仓位止盈止损）
 * @param data
 */
export function PlacePlanOrder(data: Partial<MixContractOpenParam>, header = { 'x-security-verify-cipher': null }): Promise<BaseResponse<any>> {
    return triggerInstance.post('plan/placePlanOrder', data, header)
}

export enum BatchCancelPlanType {
    PARTIAL_TPSL = 1,
    MOVE_TPSL = 2
}

export type batchCancelPlanParam = {
    planType: number // 计划类型 0 普通计划 1 止盈计划 2 止损计划
    tokenId?: string // 保证金
    symbolIdList: Array<string> //合约对列表
    businessLine: number // 业务线
    secondBusinessLine: string // 二级业务线
    containTpAndSl?: boolean // 包含止盈止损
    isAll?: boolean
    holdSide?: number // 多空方向 （撤指定仓位的分批以及移动要制定多空)
    tpslCancelType?: number //1.分批止盈止损；2.移动止盈止损
}

/**
 * 批量取消计划委托 止盈止损
 * @param data
 */
export function batchCancelPlan(data: Partial<batchCancelPlanParam>): Promise<BaseResponse<any>> {
    data.secondBusinessLine = 'N/A'
    return triggerInstance.post('plan/batchCancelPlan', data)
}

export type cancelPlanParam = {
    orderId: string
    symbolId: string //合约对id
    planType: number // 计划类型 0 普通计划 2 止盈计划 3 止损计划
    tokenId: string // 保证金
    planId: string //记录id
    businessLine: number // 业务线
    secondBusinessLine?: string
}

/**
 * 取消计划委托 止盈止损
 * @param data
 */
export function cancelPlan(data: Partial<cancelPlanParam>): Promise<BaseResponse<any>> {
    data.secondBusinessLine = 'N/A'
    return triggerInstance.post('plan/cancelPlan', data)
}

export type icePlanParam = {
    strategyId: string // 策略id
    businessLine: number // 业务线
}
/**
 * 终止冰山委托
 * @param data
 */
export function cancelIce(data: Partial<icePlanParam>): Promise<BaseResponse<any>> {
    return triggerInstance.post('/strategy/ice/cancelStrategy', data)
}
export type iceDetailParam = {
    srcId: string // 下单方srcId
    businessLine: number // 业务线
    pageNum: number //页数
    pageSize: number //每页条数
}
/**
 * 冰山委托详情
 * @param data
 */
export function queryIceStrategyDetail(data: Partial<iceDetailParam>): Promise<BaseResponse<any>> {
    return triggerInstance.post('/strategy/ice/query/queryIceOrderDetail', data)
}
// export type iceHistoryParam = {
//     businessLine: number // 业务线
//     lastEndId: number //页数
//     pageSize: number //每页条数
// }
export type historyParam = {
    businessLine: number,
    lastEndId: string,
    pageSize: number,
    symbolId: string,
    startTime: number,
    endTime: number
}
/**
 * 冰山历史委托列表
 * @param data
 */
export function queryDelegateHistory(data: Partial<historyParam>): Promise<BaseResponse<any>> {
    return triggerInstance.post('/strategy/ice/query/queryDelegateHistory', data)
}

/**
 * 设置包含已委托
 */
type delegateParam = {
    delegateFlag: number // 0 不包含 1 包含
}
export function setDelegateFlag(data: delegateParam): Promise<BaseResponse<any>> {
    return triggerInstance.post('config/delegate/flag/set', data)
}

export type updateDelegatePlanParam = {
    orderId: string
    symbolId: string //合约对id
    planType: number // 计划类型 0 普通计划 2 止盈计划 3 止损计划
    tokenId: string // 保证金
    planId: string //记录id
    executePrice: string // 执行价
    triggerType: number //触发类型 1成交价触发 2合理标记价格触发
    orderType: number // 订单类型 0 限价 1 市价
    triggerPrice: string // 触发价格
    businessLine: number // 业务线
    secondBusinessLine?: string
}

/**
 * 更新计划委托
 * @param data
 */
export function updateDelegatePlan(
    data: Partial<updateDelegatePlanParam>
): Promise<BaseResponse<any>> {
    data.secondBusinessLine = 'N/A'
    return triggerInstance.post('plan/updateDelegatePlan', data)
}

export type updateTPSLPlanParam = {
    orderId: string
    symbolId: string //合约对id
    planType: number // 计划类型 0 普通计划 2 止盈计划 3 止损计划
    tokenId: string // 保证金
    planId: string //记录id
    triggerPrice: string // 触发价格
    businessLine: number // 业务线
    secondBusinessLine?: string
    triggerType: number
}

/**
 * 更新止盈止损
 * @param data
 */
export function updateTPSLPlan(data: Partial<updateTPSLPlanParam>): Promise<BaseResponse<any>> {
    data.secondBusinessLine = 'N/A'
    return triggerInstance.post('plan/updateTPSLPlan', data)
}

export type updateMoveTPSLPlanParam = {
    orderId: string
    symbolId: string //合约对id
    planType: number // 计划类型 0 普通计划 2 止盈计划 3 止损计划
    tokenId: string // 保证金
    planId: string //记录id
    triggerPrice: string // 触发价格
    businessLine: number // 业务线
    secondBusinessLine?: string
    triggerType: number
    rangeRate?: string
    presetTPExcutePrice?: string
    presetSLExcutePrice?: string
    presetTPTriggerType?: number
    presetSLTriggerType?: number
}

/**
 * 更新仓位 移动止盈止损
 * @param data
 */
export function updateMoveTPSLPlan(
    data: Partial<updateMoveTPSLPlanParam>
): Promise<BaseResponse<any>> {
    data.secondBusinessLine = 'N/A'
    return triggerInstance.post('tracking/plan/updateTPSLPlan', data)
}

/**
 * 更新追踪委托
 * @param data
 */
export function updateTrackTPSLPlan(
    data: Partial<updateTrackTPSLPlanParam>
): Promise<BaseResponse<any>> {
    data.secondBusinessLine = 'N/A'
    return triggerInstance.post('tracking/plan/updateTrackingPlan', data)
}

export type updateTrackTPSLPlanParam = {
    orderId: string
    planType: number // 计划类型 0 普通计划 2 止盈计划 3 止损计划
    triggerType: number
    rangeRate?: string
    triggerPrice: string // 触发价格
    planId: string //记录id
    tokenId: string // 保证金
    symbolId: string //合约对id
    businessLine: number // 业务线
    secondBusinessLine?: string
}

export type updatePlanPresetParam = {
    orderId: string
    planType: number // 计划类型 0 普通计划 2 止盈计划 3 止损计划
    symbolId: string //合约对id
    tokenId: string // 保证金
    planId: string //记录id
    triggerPrice: string // 触发价格
    businessLine: number // 业务线
    secondBusinessLine?: string
    presetTPExcutePrice?: string
    presetSLExcutePrice?: string
    presetTPTriggerType?: number
    presetSLTriggerType?: number
}

/**
 * 更新计划委托 预设止盈止损
 * @param data
 */
export function updatePlanPreset(data: Partial<updatePlanPresetParam>): Promise<BaseResponse<any>> {
    data.secondBusinessLine = 'N/A'
    return triggerInstance.post('plan/updatePlanPreset', data)
}

/**
 * 更新追踪委托 预设止盈止损
 * @param data
 */
export function updateTrackPlanPreset(
    data: Partial<updateTrackPlanPresetParam>
): Promise<BaseResponse<any>> {
    data.secondBusinessLine = 'N/A'
    return triggerInstance.post('tracking/plan/updateTrackingPlanPreset', data)
}

export type updateTrackPlanPresetParam = {
    symbolId: string //合约对id
    tokenId: string // 保证金
    businessLine: number // 业务线
    secondBusinessLine?: string
    planId: string //记录id
    presetTakeProfitPriceRatio: string // 预设的止盈比例， 如果为null， 表示清除预设止盈
    presetStopLossPriceRatio: string // 预设的止损比例， 如果为null， 表示清除预设止损
}

/**
 * 混合合约 是否是交易员  与普通合约独立
 */

export type isTradeResult = {
    result: boolean
}
export function getIsTrader(): Promise<BaseResponse<isTradeResult>> {
    return triggerInstance.post('tracking/isTrader')
}

/***
 * 当前带单 跟单 设置 止盈止损
 */
export type updateTrackingTpslParam = {
    trackingNo: string
    businessLine: number
    stopProfitPrice: string
    stopLossPrice: string
    secondBusinessLine: string
    tokenId: string
    symbolId: string
}
export function updateTrackingTpsl(
    data: Partial<updateTrackingTpslParam>
): Promise<BaseResponse<any>> {
    data.secondBusinessLine = 'N/A'
    return triggerInstance.post('tracking/updateTpsl', data)
}

/***
 * 根据用户ID和币对查询是否有跟随交易员
 * @ProductCode 交易对id symbolId
 * /v1/trigger/trace/tracer/getFollowByProductCode
 */

export function getFollowByProductCode(data: { ProductCode: string }): Promise<BaseResponse<any>> {
    return triggerInstance.post('trace/tracer/getFollowByProductCode', data)
}

/***
 * 返回支持跟单的交易对列表
 * @ProductCode 交易对id symbolId
 * /v1/trigger/trace/tracer/getFollowByProductCode
 */

export function getOpenSymbol(data = { allSymbol: false }): Promise<BaseResponse<any>> {
    return triggerInstance.post('tracking/getOpenSymbol', data)
}

/***
 * 当前带单 当前跟单 列表下 平仓
 * /v1/mcp/order/trader/placeContract
 */

export function closeTrackingOrder(
    data: Partial<MixContractOpenParam>
): Promise<BaseResponse<any>> {
    return triggerInstance.post('tracking/closeTrackingOrder ', data)
}

/***
 * 当前带单 当前跟单 列表下 全部平仓
 * /v1/trigger/tracking/closeALLTrackingOrder
 */

export function closeALLTrackingOrder(
    data: Partial<MixContractOpenParam>
): Promise<BaseResponse<any>> {
    return triggerInstance.post('tracking/closeALLTrackingOrder ', data)
}

/***
 * 当前带单 当前跟单 列表下 反手
 * /v1/mcp/order/trader/placeContract
 */

export function backContract(data: Partial<MixContractOpenParam>): Promise<BaseResponse<any>> {
    return triggerInstance.post('tracking/backContract ', data)
}
